/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.metadata.contentRights";

export { $nsid };

/** Content rights and attribution information. */
type Main = { $type?: "place.stream.metadata.contentRights";

  /**
   * Name of the creator of the work.
   */
  "creator"?:string;

  /**
   * Copyright notice for the work.
   */
  "copyrightNotice"?:string;

  /**
   * Year of creation or publication.
   */
  "copyrightYear"?:number;

  /**
   * License URL or identifier.
   */
  "license"?:"place.stream.metadata.contentRights#all-rights-reserved" | "place.stream.metadata.contentRights#cc0_1__0" | "place.stream.metadata.contentRights#cc-by_4__0" | "place.stream.metadata.contentRights#cc-by-sa_4__0" | "place.stream.metadata.contentRights#cc-by-nc_4__0" | "place.stream.metadata.contentRights#cc-by-nc-sa_4__0" | "place.stream.metadata.contentRights#cc-by-nd_4__0" | "place.stream.metadata.contentRights#cc-by-nc-nd_4__0" | l.UnknownString;

  /**
   * Credit line for the work.
   */
  "creditLine"?:string };

export type { Main };

/** Content rights and attribution information. */
const main = /*#__PURE__*/ l.typedObject<Main>($nsid, "main", /*#__PURE__*/ l.object({"creator":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"copyrightNotice":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"copyrightYear":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"license":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string<{"knownValues":["place.stream.metadata.contentRights#all-rights-reserved","place.stream.metadata.contentRights#cc0_1__0","place.stream.metadata.contentRights#cc-by_4__0","place.stream.metadata.contentRights#cc-by-sa_4__0","place.stream.metadata.contentRights#cc-by-nc_4__0","place.stream.metadata.contentRights#cc-by-nc-sa_4__0","place.stream.metadata.contentRights#cc-by-nd_4__0","place.stream.metadata.contentRights#cc-by-nc-nd_4__0"]}>()),"creditLine":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);

/** All rights reserved to the creator — others cannot use, modify, or share without explicit authorization. */
type AllRightsReserved = "place.stream.metadata.contentRights#all-rights-reserved";

export type { AllRightsReserved };

/** All rights reserved to the creator — others cannot use, modify, or share without explicit authorization. */
const allRightsReserved = /*#__PURE__*/ l.token($nsid, "all-rights-reserved");

export { allRightsReserved as "all-rights-reserved" };

/** Public domain dedication. You waive all copyright and related rights where possible. Others may copy, modify, distribute, or perform your work for any purpose without attribution. */
type Cc0_1__0 = "place.stream.metadata.contentRights#cc0_1__0";

export type { Cc0_1__0 as Cc010 };

/** Public domain dedication. You waive all copyright and related rights where possible. Others may copy, modify, distribute, or perform your work for any purpose without attribution. */
const cc0_1__0 = /*#__PURE__*/ l.token($nsid, "cc0_1__0");

export { cc0_1__0 };

/** Attribution required. Others may copy, distribute, remix, and build upon your work, even commercially, if they credit you. */
type CcBy40 = "place.stream.metadata.contentRights#cc-by_4__0";

export type { CcBy40 };

/** Attribution required. Others may copy, distribute, remix, and build upon your work, even commercially, if they credit you. */
const ccBy40 = /*#__PURE__*/ l.token($nsid, "cc-by_4__0");

export { ccBy40 as "cc-by_4__0" };

/** Attribution + share-alike. Others may adapt and build upon your work, even commercially, if they credit you and license their new creations under identical terms. */
type CcBySa40 = "place.stream.metadata.contentRights#cc-by-sa_4__0";

export type { CcBySa40 };

/** Attribution + share-alike. Others may adapt and build upon your work, even commercially, if they credit you and license their new creations under identical terms. */
const ccBySa40 = /*#__PURE__*/ l.token($nsid, "cc-by-sa_4__0");

export { ccBySa40 as "cc-by-sa_4__0" };

/** Attribution + non-commercial. Others may adapt and build upon your work for non-commercial purposes only, and must credit you. */
type CcByNc40 = "place.stream.metadata.contentRights#cc-by-nc_4__0";

export type { CcByNc40 };

/** Attribution + non-commercial. Others may adapt and build upon your work for non-commercial purposes only, and must credit you. */
const ccByNc40 = /*#__PURE__*/ l.token($nsid, "cc-by-nc_4__0");

export { ccByNc40 as "cc-by-nc_4__0" };

/** Attribution + non-commercial + share-alike. Others may adapt and build upon your work for non-commercial purposes only, must credit you, and must license their new creations under identical terms. */
type CcByNcSa40 = "place.stream.metadata.contentRights#cc-by-nc-sa_4__0";

export type { CcByNcSa40 };

/** Attribution + non-commercial + share-alike. Others may adapt and build upon your work for non-commercial purposes only, must credit you, and must license their new creations under identical terms. */
const ccByNcSa40 = /*#__PURE__*/ l.token($nsid, "cc-by-nc-sa_4__0");

export { ccByNcSa40 as "cc-by-nc-sa_4__0" };

/** Attribution + no derivatives. Others may reuse your work, even commercially, but it must remain unchanged and you must be credited. */
type CcByNd40 = "place.stream.metadata.contentRights#cc-by-nd_4__0";

export type { CcByNd40 };

/** Attribution + no derivatives. Others may reuse your work, even commercially, but it must remain unchanged and you must be credited. */
const ccByNd40 = /*#__PURE__*/ l.token($nsid, "cc-by-nd_4__0");

export { ccByNd40 as "cc-by-nd_4__0" };

/** Attribution + non-commercial + no derivatives. Others may download and share your work with credit, but cannot change it or use it commercially. */
type CcByNcNd40 = "place.stream.metadata.contentRights#cc-by-nc-nd_4__0";

export type { CcByNcNd40 };

/** Attribution + non-commercial + no derivatives. Others may download and share your work with credit, but cannot change it or use it commercially. */
const ccByNcNd40 = /*#__PURE__*/ l.token($nsid, "cc-by-nc-nd_4__0");

export { ccByNcNd40 as "cc-by-nc-nd_4__0" };
